/**
 * The Help mode switch, in the top bar beside the other view controls.
 *
 * WHY IT LIVES HERE and not behind the life-buoy. Report a problem is
 * help-OUT: it opens a form that files a ticket with Nexsoss. Help mode
 * is help-IN: it explains the screen the person is already looking at.
 * Putting the second inside the first would make "I do not understand
 * this button" and "something is broken" the same gesture, and the
 * hotel would file tickets asking what a button does.
 *
 * THE DOT. Until this person has turned Help mode on once, the button
 * wears a small marker. That is the entire "seen it" mechanism Akash
 * asked for: a nudge that stops nagging. It is not a record that anyone
 * was trained, it does not follow them to another browser, and nothing
 * reports it anywhere.
 */
import { useHelpMode } from '../help';
import { IconHelpCircle } from '../design-system/icons';
import './HelpToggle.css';

export function HelpToggle() {
  const { enabled, seen, toggle } = useHelpMode();
  const label = enabled ? 'Hide help on this screen' : 'Show help on this screen';
  return (
    <button
      type="button"
      className={`nx-topbar__btn nx-help-toggle${enabled ? ' nx-help-toggle--on' : ''}`}
      data-tuck="hide"
      onClick={toggle}
      aria-label={label}
      aria-pressed={enabled}
      title={label}
      data-testid="help-toggle"
    >
      <IconHelpCircle size={16} />
      {!seen && <span className="nx-help-toggle__dot" data-testid="help-toggle-dot" aria-hidden />}
    </button>
  );
}
